import { remoteConfig } from "../firebase";

/**
 * Fetch + activate Remote Config, then return a parameter as a string.
 * Returns "" when missing. Never throws for empty values.
 */
export const fetchRemoteConfigString = async (key) => {
  await remoteConfig.fetchAndActivate();
  return remoteConfig.getValue(key).asString() || "";
};

/**
 * Parse a Remote Config JSON parameter. Returns `fallback` on empty/invalid.
 */
export const fetchRemoteConfigJson = async (key, fallback = null) => {
  try {
    const raw = await fetchRemoteConfigString(key);
    if (!raw) {
      console.warn(`Remote Config "${key}" is empty`);
      return fallback;
    }
    return JSON.parse(raw);
  } catch (err) {
    console.error(`Remote Config "${key}" failed:`, err);
    return fallback;
  }
};

/**
 * Parse a boolean Remote Config param ("true"/"false" JSON or plain).
 * Returns `fallback` when missing/invalid.
 */
export const fetchRemoteConfigBool = async (key, fallback = false) => {
  try {
    const raw = await fetchRemoteConfigString(key);
    if (!raw) {
      console.warn(`Remote Config "${key}" is empty`);
      return fallback;
    }
    const parsed = JSON.parse(raw);
    return typeof parsed === "boolean" ? parsed : Boolean(parsed);
  } catch (err) {
    console.error(`Remote Config "${key}" failed:`, err);
    return fallback;
  }
};
